import { firestore } from '../utilities/firebase'

const userProfileCheckFollowing = async ({ uid, uids }) => {
	const followingCollRef = firestore.collection('userProfiles').doc(uid).collection('following')
	const follows = await Promise.all(uids.map(async (userUid) => {
		const followingDocRef = followingCollRef.doc(userUid)
		const followingDocSnap = await followingDocRef.get()
		return { userUid, following: followingDocSnap.exists && followingDocSnap.data() }
	}))
	const followingByUid = follows.reduce((obj, follow) => {
		// eslint-disable-next-line no-param-reassign, because this is exactly the right thing to be doing in a reducer
		obj[follow.userUid] = follow.following
		return obj
	}, {})
	return { followingByUid }
}

export default userProfileCheckFollowing



// WEBPACK FOOTER //
// ./src/dataservices/userProfileCheckFollowing.js